import React, { useEffect, useState } from 'react';
import { TutorialService } from '../../services/tutorialService';

interface TutorialTestProps {
  variant?: 'inline' | 'floating';
}

export const TutorialTest: React.FC<TutorialTestProps> = ({ variant = 'floating' }) => {
  const [status, setStatus] = useState<string>('');

  const handleResetTutorial = async () => {
    setStatus('Resetting...');
    try {
      const success = await TutorialService.resetTutorial();
      setStatus(success ? 'Reset. Refresh to view.' : 'Reset failed');
    } catch (error) {
      setStatus('Error resetting');
    }
  };

  // Auto-hide status after a short delay
  useEffect(() => {
    if (!status) return;
    const t = setTimeout(() => setStatus(''), 2500);
    return () => clearTimeout(t);
  }, [status]);

  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={handleResetTutorial}
          className="px-2 py-1 text-xs rounded bg-blue-500 text-white hover:bg-blue-600 shadow-md"
          title="Reset tutorial"
        >
          Reset Tutorial
        </button>
        {status && (
          <span className="px-2 py-1 text-[11px] rounded bg-white/90 border shadow-sm text-gray-700">
            {status}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="fixed top-3 left-3 z-50">
      <div className="flex items-center gap-2">
        <button
          onClick={handleResetTutorial}
          className="px-2 py-1 text-xs rounded bg-blue-500 text-white hover:bg-blue-600 shadow-md"
          title="Reset tutorial"
        >
          Reset Tutorial
        </button>
        {status && (
          <span className="px-2 py-1 text-[11px] rounded bg-white/90 border shadow-sm text-gray-700">
            {status}
          </span>
        )}
      </div>
    </div>
  );
};
